import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { getSeoForPath, normalizePath } from "../config/seo";

/**
 * Global SEO defaults for static routes.
 * Skip dynamic blog/category pages so their own Helmet wins
 * (avoids homepage meta duplicated on every URL).
 */
const Seo = () => {
  const { pathname } = useLocation();
  const path = normalizePath(pathname);

  if (
    path.startsWith("/blog-details") ||
    path.startsWith("/category/")
  ) {
    return null;
  }

  const { title, description, canonical } = getSeoForPath(pathname);

  return (
    <Helmet key={path} defer={false}>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default Seo;
